import axios from "axios";
import { TTP_API_URL } from "Config";
import { throwCatchedError, updateSourceToken } from "Utils";

/*export const getLatestTopics = ({
  token,
  limit,
  language = "fr",
  navCommunity,
  sourceToken = null
}) => {
  const requestUrl = `${TTP_API_URL}/media/forum/latest-topics`;

  return axios
    .get(requestUrl, {
      // cancelToken: getLatestTopicsSourceToken.token,
      params: {
        access_token: token,
        organization_id: navCommunity
      }
    })
    .catch(function(thrown) {
      throwCatchedError(thrown);
    });
};*/
let getLatestTopicsSourceToken;
export const getLatestTopics = ({
  token,
  limit,
  language = "fr",
  community,
  offset = 0,
  search = null,
  sourceToken = null
}) => {
  getLatestTopicsSourceToken = updateSourceToken(
    getLatestTopicsSourceToken,
    sourceToken
  );

  const requestUrl = `${TTP_API_URL}/media/topic`;

  const fields = ["*", "user", "category", "organization", "social"];

  let filter = [
    {
      property: "language",
      value: language,
      operator: "eq"
    }
  ];

  if (community) {
    filter.push({
      property: "organization.id",
      value: community,
      operator: "eq"
    });
  }
  if (search) {
    filter.push({
      property: "search",
      value: search,
      operator: "like"
    });
  }
  const sort = [
    {
      property: "createdAt",
      dir: "desc"
    }
  ];
  return axios
    .get(requestUrl, {
      cancelToken: getLatestTopicsSourceToken.token,
      params: {
        access_token: token,
        sort: JSON.stringify(sort),
        fields: fields.join(","),
        filter: JSON.stringify(filter),
        start: offset,
        limit
      }
    })
    .catch(function(thrown) {
      throwCatchedError(thrown);
    });
};

export const getSingleTopic = (token, topicId) => {
  const filter = [{ property: "id", value: topicId, operator: "eq" }];

  const fields = ["*", "user", "tags", "category"];

  const requestUrl = `${TTP_API_URL}/media/topic`;

  return axios
    .get(requestUrl, {
      params: {
        access_token: token,
        fields: fields.join(","),
        filter: JSON.stringify(filter)
      }
    })
    .catch(function(thrown) {
      throwCatchedError(thrown);
    });
};

/*export const fetchTopicComments = ({ token, limit, objectType, objectId }) => {
  const filter = [
    {
      property: `objectId`,
      value: objectId,
      operator: "eq"
    },
    {
      property: "objectType",
      value: objectType,
      operator: "eq"
    }
  ];

  const sort = [
    {
      property: "createdAt",
      dir: "asc"
    }
  ];

  const fields = ["*", "user"];
  const requestUrl = `${TTP_API_URL}/media/comment`;

  return axios
    .get(requestUrl, {
      params: {
        access_token: token,
        filter: JSON.stringify(filter),
        sort: JSON.stringify(sort),
        fields: fields.join(","),
        limit
      }
    })
    .catch(function(thrown) {
      throwCatchedError(thrown);
    });
};*/

/*export const saveTopicComment = ({ token, comment, topicId }) => {
  const requestUrl = `${TTP_API_URL}/media/comment`;

  let formData = new FormData();
  formData.append("access_token", token);
  formData.append("objectType", "TOPIC");
  formData.append("objectId", topicId);
  formData.append("comment", comment);

  return axios.post(requestUrl, formData);
};*/



// WEBPACK FOOTER //
// ./src/api/topic.js